import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white selection:bg-brand-orange selection:text-white" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}